const custom_profile_fields = {
    /** UNTRANSLATED */
    entity_not_exists_with_names: 'Cannot find entities with the given names: {{names}}',
    invalid_min_max_input: 'Geçersiz minimum ve maksimum giriş.',
    invalid_options: 'Geçersiz alan seçenekleri.',
    invalid_regex_format: 'Geçersiz regex formatı.',
    invalid_address_parts: 'Geçersiz adres bölümleri.',
    invalid_fullname_parts: 'Geçersiz tam ad bölümleri.',
    name_exists: 'Bu isimle zaten bir alan mevcut.',
    conflicted_sie_order: 'Oturum Açma Deneyimi için çakışan alan sırası değeri.',
    /** UNTRANSLATED */
    invalid_name: 'Invalid field name, only letters or numbers are allowed, case sensitive.',
};
export default Object.freeze(custom_profile_fields);
